import './CounterBadge.css';

export type CounterBadgeSize = 'xs' | 's' | 'm' | 'l';

export interface CounterBadgeProps {
  /** Значение счётчика. Для variant='count' при 0 или меньше бейдж не рендерится */
  count?: number;
  /** Максимальное число перед подстановкой «max+» (по умолчанию 99) */
  max?: number;
  /** 'count' — красный с цифрой, 'presence' — серый без цифр, 'new' — красный без цифр */
  variant?: 'count' | 'presence' | 'new';
  /** Для variant='presence' и 'new': показывать бейдж */
  visible?: boolean;
  /** Размер: xs — 8×8, s — 12×12, m — 14×14, l — 16×16 (по умолчанию m) */
  size?: CounterBadgeSize;
  className?: string;
  /** Текст для screen readers */
  'aria-label'?: string;
}

const SIZE_CLASS: Record<CounterBadgeSize, string> = {
  xs: 'counter-badge_size_xs',
  s: 'counter-badge_size_s',
  m: 'counter-badge_size_m',
  l: 'counter-badge_size_l',
};

export function CounterBadge({
  count = 0,
  max = 99,
  variant = 'count',
  visible = false,
  size = 'm',
  className,
  'aria-label': ariaLabel,
}: CounterBadgeProps) {
  const sizeClass = SIZE_CLASS[size];
  const isPresence = variant === 'presence';
  const isNew = variant === 'new';
  if (isPresence || isNew) {
    if (!visible) return null;
    const modifierClass = isPresence ? 'counter-badge_presence' : 'counter-badge_new';
    return (
      <span
        className={['counter-badge', 'count-badge', sizeClass, modifierClass, className]
          .filter(Boolean)
          .join(' ')}
        aria-hidden="true"
        role="status"
        aria-label={ariaLabel}
      />
    );
  }

  if (count <= 0) return null;

  const display = count > max ? `${max}+` : String(count);
  const label = ariaLabel ?? (count > max ? `Больше ${max}` : String(count));

  return (
    <span
      className={['counter-badge', 'count-badge', 'count-badge--danger', sizeClass, className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
      role="status"
      aria-label={label}
    >
      {display}
    </span>
  );
}
